import { fromJS, List } from 'immutable';
import { CLOSE_MODERATE_TRAY, OPEN_MODERATE_TRAY } from '@instructure/quiz-common';
var initialState = fromJS({
  selectedParticipantName: null,
  selectedSessions: List(),
  trayOpen: false
});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case CLOSE_MODERATE_TRAY:
      return state.set('trayOpen', false);
    case OPEN_MODERATE_TRAY:
      return state.set('selectedParticipantName', action.participant.name).set('selectedSessions', List(action.participant.quizSessionIds)).set('trayOpen', true);
    default:
      return state;
  }
});